
<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			MULTI BRAND AIR DRYER
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>

	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">   
		<a class="mail-call" href="tel:8489359948">
            <span class="fa fa-phone" aria-hidden="true"></span>
        </a>  
		<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
		</a>   
		<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
			<span class="fa fa-whatsapp"></span>
		</a>
        <img src="../../../assets/img/active-product/air-dryer1.jpeg" alt="">
        <br>
        <ul>
            <li>Expert Technicians – Our team has extensive experience working with all major air dryer brands. 
                They are trained to troubleshoot, repair, and maintain any air dryer model effectively..</li>
            <li>Tailored Maintenance Plans – We offer flexible maintenance packages to suit your needs, including regular check-ups,
                 component replacements, and system optimization..</li>
            <li>&nbsp; High-Quality Parts – We use only OEM (Original Equipment Manufacturer) parts to ensure your air dryer operates at its best..</li>
            <li> If your air dryer breaks down, we offer fast, reliable service to get your system back up and running with minimal downtime.</li>
        </ul>



        <p>
            We provide professional services for all leading air dryer brands, ensuring high-quality performance and reliable operation. 
            Our technicians are experienced in servicing and repairing a wide range of air dryer models, including
        </p>
        <p>
            Refrigerated Air Dryers: Full inspection, cleaning, and refrigerant recharge services.
            Desiccant Air Dryers: Replacement of desiccant media, valve servicing, and moisture control.
        </p>
    </div>
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
	<a class="mail-call" href="tel:8489359948">
		<span class="fa fa-phone" aria-hidden="true"></span>
	</a>  
	<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
	</a>   
	<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
		<span class="fa fa-whatsapp"></span>
	</a>
    <img src="../../assets/img/multi-brand/multibrand3.jpeg" alt="">
    <br>
    <ul>
        <li>Expert Technicians – Our team has extensive experience working with all major air dryer brands. 
            They are trained to troubleshoot, repair, and maintain any air dryer model effectively..</li>
        <li>Tailored Maintenance Plans – We offer flexible maintenance packages to suit your needs, including regular check-ups,
             component replacements, and system optimization..</li>
        <li>&nbsp; High-Quality Parts – We use only OEM (Original Equipment Manufacturer) parts to ensure your air dryer operates at its best..</li>
        <li> If your air dryer breaks down, we offer fast, reliable service to get your system back up and running with minimal downtime.</li>
    </ul>



    <p>
        We provide professional services for all leading air dryer brands, ensuring high-quality performance and reliable operation. 
        Our technicians are experienced in servicing and repairing a wide range of air dryer models, including
    </p>
    <p>
        Refrigerated Air Dryers: Full inspection, cleaning, and refrigerant recharge services.
        Desiccant Air Dryers: Replacement of desiccant media, valve servicing, and moisture control.
    </p>
    </div>
